<template>
  <RemoteAutocomplete
    :id="`search-icd10-code-${props.data.searchId}`"
    ref="remoteRef"
    class="lh--force-white-background"
    :model-value="selectedCode"
    :label="props.data.label + (props.required ? '*' : '')"
    :remote-search="searchIcd10Codes"
    :allow-free-text="false"
    :disabled="props.disabled"
    :component-bind="{ noFilter: true, clearable: true, placeholder: 'Start typing ICD-10 Code or Diagnosis' }"
    @update:model-value="handleSelection"
    @keyup.esc="cleanInput" />
</template>

<script setup>
import { ref } from "vue";
import axios from "axios";
import RemoteAutocomplete from "@/components/RemoteAutocomplete.vue";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["icd10-selected"]);

const remoteRef = ref(null);
const selectedCode = ref(null);
const icd10CodeServiceQueryURL = "https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&df=code,name";

// Items keep the plain code as value and carry the name alongside, so the selection can be re-emitted as an object
const searchIcd10Codes = (search) => {
  if (!search || search.length < 3) {
    return Promise.resolve([]);
  }
  const url = `${icd10CodeServiceQueryURL}&terms=${encodeURIComponent(search)}`;
  return axios
    .get(url)
    .then((res) => res.data[3].map(([code, name]) => ({ title: `${code} - ${name}`, value: code, name })))
    .catch(() => []);
};

function handleSelection(code) {
  if (!code) {
    selectedCode.value = null;
    return;
  }
  const item = remoteRef.value?.remote.itemsRef.find((i) => i.value === code);
  if (item) {
    selectedCode.value = code;
    emit("icd10-selected", { name: item.name, icd10Code: item.value });
  }
}

function cleanInput() {
  selectedCode.value = null;
  remoteRef.value?.remote.reset("");
}
</script>
